const MAX_ENTRIES = 100;

// ─── API Log ────────────────────────────────────────────────────────────────

export interface ApiLogEntry {
  method: string;
  url: string;
  status: number | null;
  response: any;
  timestamp: string;
}

const apiLog: ApiLogEntry[] = [];

export function addApiLog(entry: ApiLogEntry) {
  if (apiLog.length >= MAX_ENTRIES) apiLog.shift();
  apiLog.push(entry);
}

export function getApiLog(): ApiLogEntry[] {
  return [...apiLog];
}

// ─── Console Log ─────────────────────────────────────────────────────────────

export type ConsoleLevel = 'log' | 'info' | 'warn' | 'error';

export interface ConsoleLogEntry {
  level: ConsoleLevel;
  args: any[];
  timestamp: string;
}

const consoleLog: ConsoleLogEntry[] = [];

export function getConsoleLog(): ConsoleLogEntry[] {
  return [...consoleLog];
}

export function initConsoleLogger() {
  const levels: ConsoleLevel[] = ['log', 'info', 'warn', 'error'];

  levels.forEach((level) => {
    const original = console[level].bind(console);
    console[level] = (...args: any[]) => {
      if (consoleLog.length >= MAX_ENTRIES) consoleLog.shift();
      consoleLog.push({ level, args, timestamp: new Date().toISOString() });
      original(...args);
    };
  });
}
